import styled from 'styled-components';

export const Container = styled.div<{ active?: boolean }>`
  position: relative;
  width: 75%;
  border-radius: 0.75rem;
  border: ${({ active }) => (active ? `4px solid green` : 'none')};

  background: #fff;

  margin-right: 5rem;
  margin-bottom: 4rem;

  cursor: pointer;

  @media (max-width: 1024px) {
    width: 100%;
    margin-right: 4rem;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 2rem;
  }
`;

export const Options = styled.div`
  position: absolute;
  right: 3%;
  top: 17%;

  background: none;

  z-index: 99;
  cursor: pointer;

  > svg {
    &:hover {
      background: #dadada;
      border-radius: 50%;
    }
  }

  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;

    position: absolute;
    left: -10rem;
    overflow: hidden;

    width: 14rem;

    background: #ffffff;

    box-shadow: 0px 0px 4px #40404030;
    border-radius: 2px;

    opacity: 0;

    transition: 300ms ease-in-out;
    pointer-events: none;

    .divider {
      height: 1px;
      background: #cbcbcb;
      margin: 0 0.3rem;
    }

    a {
      color: black;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      background: #ffffff;
      height: 4rem;
      border-radius: 0;

      color: #0f0f0f;
      font-size: 1.4rem;
      font-family: ${({ theme }) => theme.fontFamily.Nunito};
      font-weight: 600;
      line-height: 1.9rem;

      :last-child {
        color: #d90606;
      }

      &:hover {
        background: #40404030;
      }
    }
  }

  &:hover {
    > div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;

export const Fieldset = styled.fieldset`
  border: none;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 3rem;
`;

export const Title = styled.h2`
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 0.6rem;
  padding: 0 2rem;
`;

export const Text = styled.p`
  font-size: 1.8rem;
  margin-bottom: 0.6rem;
  text-align: center;
  padding: 0 2rem;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`;

export const ModalButton = styled.button`
  color: #fff;
  font-size: 2rem;
  font-weight: bold;

  padding: 1.25rem 3rem;

  background: transparent linear-gradient(98deg, #000000 0%, #232323 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 5rem;

  transition: 0.2s;

  :hover {
    filter: opacity(0.9);
  }
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  padding: 1rem 2.6rem;
`;

export const LineWrapper = styled.span`
  font-size: 1.6rem;
  margin: 0.3rem 0;
  display: flex;
  align-items: start;
  gap: 0.25rem;
`;

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;

  h1 {
    margin-bottom: 2rem;
  }

  .profile-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
  }

  .sheet-model {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h3 {
      color: #00000080;
    }
  }
`;

export const MuscleGroupContainer = styled.div`
  margin: 4rem;
  margin-top: 0;
`;

type CheckButtonProps = {
  isSelected?: boolean;
};

export const CheckButton = styled.button.attrs({
  type: 'button',
})<CheckButtonProps>`
  margin-bottom: 0.5rem;
  background: transparent;

  display: flex;

  align-items: center;

  .radio {
    width: 2.2rem;
    height: 2.2rem;
    background: #fff;

    border: 1px solid #000;
    border-radius: 0.4rem;
  }

  .filled {
    width: 100%;
    height: 100%;
    border: 1px solid #fff;
    border-radius: 0.4rem;

    background: ${({ isSelected }) => (isSelected ? '#000' : false)};
  }

  p {
    color: #000;

    font-size: 1.8rem;
    padding: 0 0.5rem;
    text-transform: capitalize;
  }

  :active {
    filter: opacity(0.8);
  }
`;
